import Route from '@ember/routing/route';
import { setProperties } from '@ember/object';
import RSVP from 'rsvp';
import { service } from '@ember/service';

export default class AdminFundsIndexRoute extends Route {
  @service fundsService;
  @service navbarSettings;
  @service storeCache;

  queryParams = {
    q: {
      replace: true,
    },
  };

  beforeModel() {
    this.navbarSettings.title = 'Funds';
    return this.fundsService.confirmValidFundToken();
  }

  model() {
    let promise = RSVP.hash({
      usersById: this.storeCache.indexSingleBy('admin/user', 'id'),
      funds: this.storeCache.findAll('admin/fund'),
      userFundsByFundId: this.storeCache.indexMultipleBy(
        'admin/user-fund',
        'fundId',
      ),
    });
    return promise.then((data) => {
      let model = [];
      data.funds.forEach((fund) => {
        let userFunds = data.userFundsByFundId[fund.id] || [];
        model.push({
          fund: fund,
          users: userFunds
            .map((userFund) => data.usersById[userFund.userId])
            .filter((user) => user?.role === 'User'),
        });
      });
      return model;
    });
  }

  setupController(controller) {
    super.setupController(...arguments);
    let params = this.paramsFor('admin.funds.index');
    setProperties(controller, {
      q: params.q,
      qInput: params.q,
    });
  }
}
